import React from "react";
import Helmet from "react-helmet";
import { robotMetaTag } from "../../utils/constants";
import icon from "../../images/xometry-logo-fav.png";

export interface ISeoProps {
  meta_title?: string | null | undefined;
  meta_description?: string | null | undefined;
  title?: string | null | undefined;
  description?: string | null | undefined;
  image?: string | null | undefined;
  lang?: string | null | undefined;
  robots?: string | null | undefined;
}

type SeoImageField = { url?: string | null } | null | undefined;

export type SeoSlicePrimary = {
  meta_title?: string | null;
  meta_description?: string | null;
  meta_image?: SeoImageField;
  json_ld?: string | null;
};

// GraphQL types may lag behind the Prismic schema until codegen runs.
export const getSeoMetaImage = (primary: unknown) =>
  (primary as SeoSlicePrimary | null | undefined)?.meta_image;

// Prefer the SEO slice image for og/twitter tags; fall back to the page hero image.
export const resolveSeoImage = (
  metaImage?: SeoImageField,
  fallback?: string | null
) => metaImage?.url || fallback || undefined;

export const SEO = (props: ISeoProps) => {
  const defaultDescription =
    "Turbocharge the way you order custom parts with our instant quoting engine. Get DFM feedback, lead times, and pricing in a matter of clicks, not days.";
  const defaultTitle = "Xometry";
  const lang = props?.lang || "en-US";
  const title = props?.title || props?.meta_title || defaultTitle;
  const metaTitle = props?.meta_title || props?.title || defaultTitle;
  const metaDescription =
    props?.meta_description || props?.description || defaultDescription;
  const image =
    props?.image ||
    "https://images.prismic.io/xometry-marketing/06058e13-27c3-46eb-b29d-d250b7f926dc_xometry-logo.png?auto=compress,format";
  const description =
    props?.description || props?.meta_description || defaultDescription;
  const robots = props?.robots;
  const siteWideRobots = robotMetaTag;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
    >
      <link rel="icon" href={icon} />
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@xometry" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {robots && <meta name="robots" content={robots} />}
      {siteWideRobots && <meta name="robots" content={siteWideRobots} />}
    </Helmet>
  );
};
